import React from 'react';
import { Lock, ShieldAlert, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

const ModuleDisabled = ({ moduleName }) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 animate-in fade-in zoom-in duration-300">
            <div className="relative mb-6">
                <div className="h-24 w-24 rounded-full bg-amber-50 flex items-center justify-center border-2 border-amber-100 shadow-sm relative z-10">
                    <Lock className="h-10 w-10 text-amber-500" />
                </div>
                <div className="absolute -top-1 -right-1 h-8 w-8 rounded-full bg-white flex items-center justify-center border border-slate-100 shadow-sm z-20">
                    <ShieldAlert className="h-5 w-5 text-red-500" />
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-40 w-40 bg-amber-100/30 rounded-full blur-3xl -z-10" />
            </div>

            <h1 className="text-3xl font-bold text-slate-900 mb-2">Access Restricted</h1>
            <p className="text-slate-500 max-w-md mb-8 leading-relaxed">
                The <span className="font-semibold text-slate-700 capitalize">{moduleName?.replace(/_/g, ' ')}</span> module is currently disabled for your company. Please contact your administrator to enable this feature.
            </p>

            <div className="flex items-center gap-4">
                <Button
                    variant="outline"
                    onClick={() => navigate(-1)}
                    className="bg-white hover:bg-slate-50 border-slate-200"
                >
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Go Back
                </Button>
                <Button
                    onClick={() => navigate('/dashboard')}
                    className="bg-indigo-600 hover:bg-indigo-700 shadow-lg shadow-indigo-100"
                >
                    Return Home
                </Button>
            </div>

            <div className="mt-12 p-4 bg-slate-50 rounded-lg border border-slate-100 max-w-sm">
                <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">Support Info</p>
                <p className="text-xs text-slate-500 italic">
                    If you believe this is an error, please reach out to your IT department or HR manager for access rights.
                </p>
            </div>
        </div>
    );
};

export default ModuleDisabled;
